var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 136,
    viewBox: "0 0 91 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.5 136C67.8675 136 86 133.985 86 131.5C86 129.015 67.8675 127 45.5 127C23.1325 127 5 129.015 5 131.5C5 133.985 23.1325 136 45.5 136Z",
    fill: "#9888B6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91 45.4006C91 81.1443 61.5804 107.994 50.0538 117.142C47.3755 119.267 43.5874 119.281 40.8871 117.184C29.3201 108.203 0 81.8452 0 45.4006C0 20.3264 20.3711 0 45.5003 0C70.6296 0 91.0006 20.3264 91.0006 45.4006H91Z",
    fill: "#FF7351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.5003 79.097C64.1511 79.097 79.2706 64.0106 79.2706 45.4007C79.2706 26.7907 64.1511 11.7043 45.5003 11.7043C26.8495 11.7043 11.73 26.7907 11.73 45.4007C11.73 64.0106 26.8495 79.097 45.5003 79.097Z",
    fill: "#DED7ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.c27e121036ec5543f76fc41db3ed213a.svg";
export { ForwardRef as ReactComponent };